/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { MainRoutes } from "./main-routes";
// import { Logger } from "cms/utils/log/logger";

const Routes = () => {

    const routes = useRoutes([MainRoutes]);
    // return routes;
    return (
        <Suspense fallback={<div>Loading page...</div>}>
            {routes}
        </Suspense>
    );
};

export { Routes };
